import { Component, inject, signal, viewChild } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { DiceColor, DiceService } from '../../services/dice-service.service';
import { RidDiceSlot } from '../rid-dice-slot/rid-dice-slot';
import { RidDice } from '../rid-dice/rid-dice';
import { RidModalBackground } from '../rid-modal-background/rid-modal-background';

@Component({
  selector: 'rid-dice-overlay',
  imports: [RidModalBackground, RidDice, RidDiceSlot],
  templateUrl: './rid-dice-overlay.html',
  host: {
    class: 'block pointer-events-none absolute inset-0 overflow-hidden',
  },
})
export class RidDiceOverlay {
  protected readonly $diceService = inject(DiceService);

  readonly centerDice = viewChild<RidDice>('centerDice');
  dice = signal<{ faces: string[] | undefined; color: DiceColor } | undefined>(undefined);
  readonly numericDice = signal<number | undefined>(undefined);

  constructor() {
    this.$diceService.registerAnimationHandler((color, faces, result) => this.rollCenterDice(color, faces, result));
  }

  async toggleNumericDice() {
    if (this.numericDice()) {
      this.numericDice.set(undefined);
    } else {
      this.numericDice.set(await this.$diceService.roll('EMERALD'));
    }
  }

  private async rollCenterDice(color: DiceColor, faces: string[] | undefined, result: number): Promise<void> {
    this.dice.set({ faces, color });

    await delay(50);

    const center = this.centerDice();

    if (!center) {
      throw new Error('Dice not initialized');
    }

    // Show and roll the center dice
    await center.roll(result);

    // Present the result (scale up)
    await center.present();

    this.dice.set(undefined); // hide center dice
  }
}
